<template>
<main>
    <section id="uebermich" aria-label="&Uuml;ber mich">
      <div class="blue-outline">
      <div class="flex-group">
        <div>
          <img src="../assets/img/home/sabine1.png" alt="" width="300" height="300">
        </div>

        <div class="text text-wide blue-text">
            <h2>Sabine Döbrössy BSc</h2>
            <ul aria-label="Qualififationen">
              <li>
                Übungsleiter Reiten
              </li>
              <li>
                Centered Riding<sup>&#174;</sup> Instructor
              </li>
              <li>
                Neuro-Rider<sup>&#174;</sup> Trainer
              </li>
              <li>
                Becken-Trainer für Reiter nach der Franklin-Methode<sup>&#174;</sup>
              </li>
            </ul>
        </div>
      </div>
      </div>

    <div class="grey-box">
      <div class="flex-group">
        <!-- <div class="content-container"> -->
          <div class="text">
           <p>
            Die große Liebe zu Pferden begleitet mich schon ein Leben lang. 
            Verstehen zu können, was Pferde uns sagen wollen, wie sie behandelt werden 
            möchten und was sie brauchen um gesund, kraftvoll und lebensfroh zu sein, bedeutet mir alles. 
            Pferde haben mich gelehrt immer neue Wege zu suchen, denn man lernt nie aus. 
            </p>
          </div>
          <div>
            <img src="../assets/img/home/sabine2.png" alt="">
          </div>
        <!-- </div> -->
      </div>
    </div>
    </section>

      <!-- <div class="red-box">
        <div class="flex-group">
          <div class="content-container">
            <div class="text">
              <p>
                TODO: Warum ich tue, was ich tue?
               
               </p>
            </div>

            <div>
              <img src="../assets/img/home/angebot-mobil2.png" alt="">
             </div>
          </div>
        </div>
      </div> 
    </section>-->

  
  </main>

</template>

<script>

import Slider from "./shared/Slider.vue";

export default {
  name: "About", //this is the name of the component


  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
 metaInfo() {
        return { 
            title: "Pferdeverstand - Sabine Döbrössy",
            meta: [
              { name: 'description', content: 'Pferdeverstand.at - Training und Gesundheit für Reiter und Pferd' },
              { property: 'og:title', content: "Pferdeverstand.at - für alle, die mit ihrem Pferd weiterkommen wollen."},
              { property: 'og:description', content: 'Sabine D&ouml;br&ouml;ssy - Über mich'},
              { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
              { property: 'og:url', content: 'www.pferdeverstand.at/about'}
            ]
        }
}

};

// Todo Meta
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/About.vue